import t from 'utils/translationHelper';
import * as yup from 'yup';

export const PO_BOX_RESTRICTED_COUNTRIES = ['CA', 'MX', 'AU'];

export const PO_BOX_REGEX = /^(?!.*\b(P\.?\s?O\.?\s?Box|P\.?\s?O\.?\s?B\.?|P\.?\s?O\.?\s?Bx|PO\.?\s?Box|PO\.?\s?B\.?|PO\.?\s?Bx|Post\s?Office\s?Box|Box\s?No\.?|Box\s?#|Box\s?\d+|Lockbox|P\.?\s?O\.?\s?B\.?|P\.?\s?O\.?\s?Bx|P\s?O\s?Box\s?No\.?)\b).{0,1000}$/i;

export const containsPOBox = (value?: string): boolean => {
  if (!value) return false;
  console.log('value', value);
  return !PO_BOX_REGEX.test(value);
};

export const isCountryPOBoxRestricted = (countryCode?: string): boolean => !!countryCode && PO_BOX_RESTRICTED_COUNTRIES.includes(countryCode);

export const addPOBoxValidation = (
  schema: yup.StringSchema,
  countryCode?: string,
): yup.StringSchema => {
  if (isCountryPOBoxRestricted(countryCode)) {
    return schema.test(
      'no-po-box',
      t('po_box_address_not_allowed'),
      (value) => !value || PO_BOX_REGEX.test(value),
    );
  }
  return schema;
};

export const beneAddressHasPOBoxIssue = (
  countryCode?: string,
  addressLine1?: string,
  addressLine2?: string,
): boolean => {
  if (!isCountryPOBoxRestricted(countryCode)) return false;
  return containsPOBox(addressLine1) || containsPOBox(addressLine2);
};
